import { toString, Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, string_type, option_type, record_type, bool_type, array_type, int32_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Role, Role__get_Identifier, Route_RouteState_AllStatuses, Route_RouteState_get_FromIdentifier, VesselRoute_FromId_Z524259A4, Route_RouteState_FromInt_Z524259A4, Route_RouteState, Route_RouteState__get_Identifier } from "../Shared/Shared.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { choose, tryFind, contains, append, sortByDescending, sortBy, map } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { createObj, int32ToString, uncurry2, safeHash, equals, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Company_$reflection, Route_$reflection } from "../Shared/ApiDataTypes.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { ListFilter, setRouteListFilter, RouteListPreferences, setRouteListPreferences, tryGetRouteListFilter, tryGetRouteListPreferences } from "../LocalStorage.js";
import { now, toString as toString_1 } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { isBig as isBig_1, filteredUserCompanies } from "../Utils.js";
import { Array_distinct, Array_except } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { bind, unwrap, map as map_1, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString as toString_2 } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { ErrorHandling_snackError, wrapTooltip, simpleCaption, responsiveCard } from "../ViewHelpers.js";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { FormControlLabel, Button, IconButton, TextField, Checkbox, Autocomplete, TableBody, TableHead, TableRow, Table, Link, TableCell, Typography } from "@mui/material";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_1, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import { globalCtx } from "../Context.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { Company_fetchCompanies } from "../Promises.js";
import { RouteForm } from "./RouteForm.js";
import Add from "@mui/icons-material/Add";
import Apps from "@mui/icons-material/Apps";
import ViewList from "@mui/icons-material/ViewList";

class FilterCategory extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Company", "Status"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Status" : "Selskap";
    }
}

function FilterCategory_$reflection() {
    return union_type("RouteList.FilterCategory", [], FilterCategory, () => [[], []]);
}

export class RouteFilter extends Record {
    constructor(Companies, Status, Page, Favorites) {
        super();
        this.Companies = Companies;
        this.Status = Status;
        this.Page = (Page | 0);
        this.Favorites = Favorites;
    }
}

export function RouteFilter_$reflection() {
    return record_type("RouteList.RouteFilter", [], RouteFilter, () => [["Companies", array_type(int32_type)], ["Status", array_type(int32_type)], ["Page", int32_type], ["Favorites", bool_type]]);
}

export function RouteFilter_Default_4F10E657(userCompanies) {
    return new RouteFilter(userCompanies, new Int32Array([Route_RouteState__get_Identifier(new Route_RouteState(0, []))]), 0, false);
}

export function RouteFilter__ToQueryVars(this$) {
    const companies = (this$.Companies.length === 0) ? "" : join("", map((x) => (`&company=${x}`), this$.Companies));
    return (("?" + ((this$.Status.length === 0) ? "" : join("", map((x_1) => (`&status=${x_1}`), this$.Status)))) + companies) + (`&favorites=${this$.Favorites}`);
}

class Presentation extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Cards", "List"];
    }
}

function Presentation_$reflection() {
    return union_type("RouteList.Presentation", [], Presentation, () => [[], []]);
}

function Presentation_FromInt_Z524259A4(x) {
    if (x === 2) {
        return new Presentation(1, []);
    }
    else {
        return new Presentation(0, []);
    }
}

function Presentation__ToInt(this$) {
    if (this$.tag === 1) {
        return 2;
    }
    else {
        return 1;
    }
}

class SortOrder extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NameDesc", "NameAsc", "NumberDesc", "NumberAsc", "StatusDesc", "StatusAsc"];
    }
}

function SortOrder_$reflection() {
    return union_type("RouteList.SortOrder", [], SortOrder, () => [[], [], [], [], [], []]);
}

function sortRoutes(x, y) {
    switch (y.tag) {
        case 1:
            return sortBy((r_1) => r_1.Name, x, {
                Compare: comparePrimitives,
            });
        case 2:
            return sortByDescending((r_2) => r_2.Number, x, {
                Compare: comparePrimitives,
            });
        case 3:
            return sortBy((r_3) => r_3.Number, x, {
                Compare: comparePrimitives,
            });
        case 5:
            return sortBy((r_4) => toString(Route_RouteState_FromInt_Z524259A4(r_4.Status)), x, {
                Compare: comparePrimitives,
            });
        case 4:
            return sortByDescending((r_5) => toString(Route_RouteState_FromInt_Z524259A4(r_5.Status)), x, {
                Compare: comparePrimitives,
            });
        default:
            return sortByDescending((r) => r.Name, x, {
                Compare: comparePrimitives,
            });
    }
}

class Model extends Record {
    constructor(Routes, Companies, Filter, FreeText, ExpandedFilters, CurrentPres, Sort, ShowAddForm, DrawerOpen, ErrorMsg) {
        super();
        this.Routes = Routes;
        this.Companies = Companies;
        this.Filter = Filter;
        this.FreeText = FreeText;
        this.ExpandedFilters = ExpandedFilters;
        this.CurrentPres = CurrentPres;
        this.Sort = Sort;
        this.ShowAddForm = ShowAddForm;
        this.DrawerOpen = DrawerOpen;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("RouteList.Model", [], Model, () => [["Routes", array_type(Route_$reflection())], ["Companies", option_type(array_type(Company_$reflection()))], ["Filter", RouteFilter_$reflection()], ["FreeText", string_type], ["ExpandedFilters", array_type(FilterCategory_$reflection())], ["CurrentPres", Presentation_$reflection()], ["Sort", SortOrder_$reflection()], ["ShowAddForm", bool_type], ["DrawerOpen", bool_type], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RoutesResponse", "CompaniesResponse", "UpdatePresentation", "SetSort", "SetDrawerOpen", "SetShowAddForm", "AddRoute", "ToggleFilterExpanded", "UpdateFilter", "UpdateFreeText", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("RouteList.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Route_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Route_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Company_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", array_type(Company_$reflection())]], [["ErrorValue", string_type]]])]], [["Item", Presentation_$reflection()]], [["Item", SortOrder_$reflection()]], [["Item", bool_type]], [["Item", bool_type]], [["Item", Route_$reflection()]], [["Item", FilterCategory_$reflection()]], [["Item", RouteFilter_$reflection()]], [["Item", string_type]], []]);
}

function init(userCompanies) {
    let f_1;
    let presentation;
    const matchValue = tryGetRouteListPreferences();
    presentation = ((matchValue != null) ? Presentation_FromInt_Z524259A4(matchValue.Presentation) : (new Presentation(1, [])));
    let storedFilter;
    const matchValue_1 = tryGetRouteListFilter();
    if (matchValue_1 != null) {
        const f = matchValue_1;
        storedFilter = ((f.Date !== toString_1(now(), "yyyy-MM-dd")) ? undefined : f);
    }
    else {
        storedFilter = undefined;
    }
    return new Model([], undefined, (storedFilter != null) ? ((f_1 = storedFilter, new RouteFilter(f_1.Companies, f_1.Status, RouteFilter_Default_4F10E657(new Int32Array([])).Page, f_1.Favorites))) : RouteFilter_Default_4F10E657(filteredUserCompanies(userCompanies)), "", [new FilterCategory(0, []), new FilterCategory(1, [])], presentation, new SortOrder(1, []), false, false, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1: {
            const x_1 = msg.fields[0];
            if (x_1.tag === 1) {
                return new Model(model.Routes, model.Companies, model.Filter, model.FreeText, model.ExpandedFilters, model.CurrentPres, model.Sort, model.ShowAddForm, model.DrawerOpen, x_1.fields[0]);
            }
            else {
                return new Model(model.Routes, x_1.fields[0], model.Filter, model.FreeText, model.ExpandedFilters, model.CurrentPres, model.Sort, model.ShowAddForm, model.DrawerOpen, model.ErrorMsg);
            }
        }
        case 2: {
            const x_2 = msg.fields[0];
            setRouteListPreferences(new RouteListPreferences(Presentation__ToInt(x_2)));
            return new Model(model.Routes, model.Companies, model.Filter, model.FreeText, model.ExpandedFilters, x_2, model.Sort, model.ShowAddForm, model.DrawerOpen, model.ErrorMsg);
        }
        case 3: {
            const x_3 = msg.fields[0];
            return new Model(sortRoutes(model.Routes, x_3), model.Companies, model.Filter, model.FreeText, model.ExpandedFilters, model.CurrentPres, x_3, model.ShowAddForm, model.DrawerOpen, model.ErrorMsg);
        }
        case 4:
            return new Model(model.Routes, model.Companies, model.Filter, model.FreeText, model.ExpandedFilters, model.CurrentPres, model.Sort, model.ShowAddForm, msg.fields[0], model.ErrorMsg);
        case 5:
            return new Model(model.Routes, model.Companies, model.Filter, model.FreeText, model.ExpandedFilters, model.CurrentPres, model.Sort, msg.fields[0], model.DrawerOpen, model.ErrorMsg);
        case 6:
            return new Model(append([msg.fields[0]], model.Routes), model.Companies, model.Filter, model.FreeText, model.ExpandedFilters, model.CurrentPres, model.Sort, false, model.DrawerOpen, model.ErrorMsg);
        case 7: {
            const category = msg.fields[0];
            return new Model(model.Routes, model.Companies, model.Filter, model.FreeText, contains(category, model.ExpandedFilters, {
                Equals: equals,
                GetHashCode: safeHash,
            }) ? Array_except([category], model.ExpandedFilters, {
                Equals: equals,
                GetHashCode: safeHash,
            }) : Array_distinct(append(model.ExpandedFilters, [category]), {
                Equals: equals,
                GetHashCode: safeHash,
            }), model.CurrentPres, model.Sort, model.ShowAddForm, model.DrawerOpen, model.ErrorMsg);
        }
        case 8: {
            const x_9 = msg.fields[0];
            setRouteListFilter(new ListFilter(x_9.Companies, x_9.Status, x_9.Favorites, toString_1(now(), "yyyy-MM-dd")));
            return new Model(model.Routes, model.Companies, x_9, model.FreeText, model.ExpandedFilters, model.CurrentPres, model.Sort, model.ShowAddForm, model.DrawerOpen, model.ErrorMsg);
        }
        case 9:
            return new Model(model.Routes, model.Companies, model.Filter, msg.fields[0], model.ExpandedFilters, model.CurrentPres, model.Sort, model.ShowAddForm, model.DrawerOpen, model.ErrorMsg);
        case 10:
            return new Model(model.Routes, model.Companies, model.Filter, model.FreeText, model.ExpandedFilters, model.CurrentPres, model.Sort, model.ShowAddForm, model.DrawerOpen, undefined);
        default: {
            const x = msg.fields[0];
            if (x.tag === 1) {
                return new Model(model.Routes, model.Companies, model.Filter, model.FreeText, model.ExpandedFilters, model.CurrentPres, model.Sort, model.ShowAddForm, model.DrawerOpen, "Kunne ikke laste sambandsoversikt. Vennligst prøv igjen senere.");
            }
            else {
                return new Model(sortRoutes(x.fields[0], model.Sort), model.Companies, model.Filter, model.FreeText, model.ExpandedFilters, model.CurrentPres, model.Sort, model.ShowAddForm, model.DrawerOpen, model.ErrorMsg);
            }
        }
    }
}

function fetchRouteList(filter, dispatch) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let decoder, data_1, caseStrategy_2, extra_2;
        const requestPath = `/api/route/list${RouteFilter__ToQueryVars(filter)}`;
        return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Route_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString_2(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Route_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))).then((_arg_2) => {
            dispatch(new Message(0, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_1.then();
}

export function responsiveRouteCard(styles, x, companyName) {
    return responsiveCard(styles, RouterModule_encodeParts(ofArray(["routes", int32ToString(x.Id), "info"]), 1), `Bilde ruten ${x.Name}`, "/images/route_default.jpg", [MuiHelpers_createElement(Typography, [["variant", "caption"], ["children", x.Number]]), MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", x.Name]]), simpleCaption(companyName), simpleCaption(toString(Route_RouteState_FromInt_Z524259A4(x.Status)))]);
}

function drawCards(model, isMobile) {
    let elems_2;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        gap: 1 + "rem",
    }], (elems_2 = [map((route) => {
        let elems, elems_1;
        const companyName = defaultArg(map_1((y_2) => y_2.Name, bind((array_2) => tryFind((y_1) => (y_1.Id === route.CompanyId), array_2), model.Companies)), "");
        if (isMobile) {
            return createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexGrow: 1,
                flexBasis: 0,
                flexShrink: 1,
                minWidth: 250,
            }], (elems = [responsiveRouteCard([], route, companyName)], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }
        else {
            return createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexGrow: 1,
                flexBasis: 0,
                flexShrink: 1,
                minWidth: 225,
                maxWidth: 225,
            }], (elems_1 = [responsiveRouteCard([], route, companyName)], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        }
    }, sortBy((e) => e.Number.toLocaleLowerCase(), model.Routes.filter((v) => {
        if (model.FreeText.trim() === "") {
            return true;
        }
        else {
            return v.Name.toLocaleLowerCase().indexOf(model.FreeText.trim().toLocaleLowerCase()) >= 0;
        }
    }), {
        Compare: comparePrimitives,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function drawList(model, dispatch, isBig) {
    let elements_6, children_3, children_2, children_4;
    const th$0027 = (title, sort, revSort) => MuiHelpers_createElement(TableCell, toList(delay(() => append_1(singleton(["variant", "head"]), delay(() => append_1(!isBig ? singleton(["size", "small"]) : empty_1(), delay(() => append_1(singleton(["style", {
        cursor: "pointer",
    }]), delay(() => append_1(singleton(["onClick", (_arg) => {
        dispatch(new Message(3, [equals(model.Sort, sort) ? revSort : sort]));
    }]), delay(() => {
        let elements, elems_1, elems;
        return singleton((elements = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
        }], (elems_1 = [title, createElement("div", createObj(ofArray([["style", {
            width: 15,
            height: 15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }], (elems = toList(delay(() => {
            let props_3, props_1;
            return equals(model.Sort, sort) ? singleton((props_3 = {
                style: {
                    fontSize: 0.9 + "rem",
                },
            }, react.createElement(ArrowUpward, props_3))) : (equals(model.Sort, revSort) ? singleton((props_1 = {
                style: {
                    fontSize: 0.9 + "rem",
                },
            }, react.createElement(ArrowDownward, props_1))) : empty_1());
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elements))]));
    })))))))))));
    const thNoSort = (title_1) => MuiHelpers_createElement(TableCell, toList(delay(() => append_1(singleton(["variant", "head"]), delay(() => append_1(!isBig ? singleton(["size", "small"]) : empty_1(), delay(() => singleton(["children", title_1]))))))));
    const tda = (fixedWidth, x, routeId) => MuiHelpers_createElement(TableCell, toList(delay(() => append_1(fixedWidth ? singleton(["style", {
        width: 190,
    }]) : empty_1(), delay(() => append_1(singleton(["size", "small"]), delay(() => append_1(singleton(["variant", "body"]), delay(() => {
        let elements_1;
        return singleton((elements_1 = [MuiHelpers_createElement(Link, [["href", RouterModule_encodeParts(ofArray(["routes", int32ToString(routeId), "info"]), 1)], ["children", x]])], ["children", reactApi.Children.toArray(Array.from(elements_1))]));
    })))))))));
    const td$0027 = (txt) => MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["children", txt]]);
    return MuiHelpers_createElement(Table, [["size", "small"], (elements_6 = [(children_3 = singleton_1((children_2 = toList(delay(() => append_1(singleton(th$0027("Navn", new SortOrder(0, []), new SortOrder(1, []))), delay(() => append_1(singleton(th$0027("Sambandsnummer", new SortOrder(2, []), new SortOrder(3, []))), delay(() => (isBig ? append_1(singleton(th$0027("Status", new SortOrder(4, []), new SortOrder(5, []))), delay(() => append_1(singleton(thNoSort("Postadresse")), delay(() => append_1(singleton(thNoSort("Postnummer")), delay(() => append_1(singleton(thNoSort("Poststed")), delay(() => singleton(thNoSort("Fartøy")))))))))) : empty_1()))))))), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_2))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_3))]])), (children_4 = map((x_1) => {
        let elems_8;
        return MuiHelpers_createElement(TableRow, [(elems_8 = toList(delay(() => append_1(singleton(tda(false, x_1.Name, x_1.Id)), delay(() => append_1(singleton(tda(true, x_1.Number, x_1.Id)), delay(() => (isBig ? append_1(singleton(td$0027(toString(Route_RouteState_FromInt_Z524259A4(x_1.Status)))), delay(() => append_1(singleton(td$0027(x_1.Address)), delay(() => append_1(singleton(td$0027(x_1.PostalCode)), delay(() => append_1(singleton(td$0027(x_1.PostalArea)), delay(() => {
            let elements_4, elems_6;
            return singleton(MuiHelpers_createElement(TableCell, [["variant", "body"], ["size", "small"], (elements_4 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexWrap: "wrap",
                gap: ((0 + "px ") + 5) + "px",
            }], (elems_6 = map((v_2) => {
                const x_3 = createElement("span", {
                    style: {
                        userSelect: "none",
                    },
                    children: `${v_2.Name},`,
                });
                return wrapTooltip(toString(VesselRoute_FromId_Z524259A4(v_2.RouteType)), x_3);
            }, sortBy((v_1) => v_1.RouteType, x_1.Vessels, {
                Compare: comparePrimitives,
            })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elements_4))])]));
        })))))))) : empty_1()))))))), ["children", reactApi.Children.toArray(Array.from(elems_8))])]);
    }, model.Routes.filter((v) => {
        if (model.FreeText.trim() === "") {
            return true;
        }
        else {
            return v.Name.toLocaleLowerCase().indexOf(model.FreeText.trim().toLocaleLowerCase()) >= 0;
        }
    })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_4))]]))], ["children", reactApi.Children.toArray(Array.from(elements_6))])]);
}

export const growingAutocompleteStyle = ofArray([["maxWidth", 400], ["minWidth", 250], ["flexGrow", 2]]);

export function drawRouteStateFilter(states, selected, setSelection) {
    const selected_1 = map(Route_RouteState_get_FromIdentifier(), selected);
    return MuiHelpers_createElement(Autocomplete, [["size", "small"], ["openOnFocus", true], ["selectOnFocus", true], ["clearOnBlur", true], ["handleHomeEndKeys", true], ["disableCloseOnSelect", true], ["multiple", true], ["options", Array.from(states)], ["isOptionEqualToValue", ((x, y) => (Route_RouteState__get_Identifier(x) === Route_RouteState__get_Identifier(y)))], ["getOptionLabel", toString], ["style", createObj(growingAutocompleteStyle)], ["value", Array.from(selected_1)], ["onChange", (_arg, v, _arg_1) => {
        setSelection(map(Route_RouteState__get_Identifier, v, Int32Array));
    }], ["renderOption", (delegateArg, delegateArg_1, delegateArg_2) => {
        const props = Object.entries(delegateArg);
        const p = delegateArg_1;
        return createElement("li", createObj(toList(delay(() => append_1(props, delay(() => append_1(singleton(["key", `${Route_RouteState__get_Identifier(p)}`]), delay(() => {
            let elems;
            return singleton((elems = [MuiHelpers_createElement(Checkbox, [["checked", delegateArg_2.selected], ["style", {
                marginRight: 8,
            }]]), toString(p)], ["children", reactApi.Children.toArray(Array.from(elems))]));
        }))))))));
    }], ["renderInput", (p_1) => MuiHelpers_createElement(TextField, toList(delay(() => append_1(Object.entries(p_1), delay(() => append_1(singleton(["variant", "outlined"]), delay(() => append_1(singleton(["color", "primary"]), delay(() => singleton(["label", "Status"]))))))))))]]);
}

export function drawCompanyFilter(companies, selected, setSelection) {
    const selected_1 = choose((i) => tryFind((y) => (y.Id === i), companies), selected);
    return MuiHelpers_createElement(Autocomplete, [["noOptionsText", "Ingen selskap"], ["size", "small"], ["openOnFocus", true], ["selectOnFocus", true], ["clearOnBlur", true], ["handleHomeEndKeys", true], ["disableCloseOnSelect", true], ["multiple", true], ["options", Array.from(companies)], ["isOptionEqualToValue", ((x, y_1) => (x.Id === y_1.Id))], ["getOptionLabel", (x_1) => x_1.Name], ["style", createObj(growingAutocompleteStyle)], ["value", Array.from(selected_1)], ["onChange", (_arg, v, _arg_1) => {
        setSelection(map((x_3) => x_3.Id, v, Int32Array));
    }], ["renderOption", (delegateArg, delegateArg_1, delegateArg_2) => {
        const props = Object.entries(delegateArg);
        const p = delegateArg_1;
        return createElement("li", createObj(toList(delay(() => append_1(props, delay(() => append_1(singleton(["key", `${p.Id}-${p.Name}`]), delay(() => {
            let elems;
            return singleton((elems = [MuiHelpers_createElement(Checkbox, [["checked", delegateArg_2.selected], ["style", {
                marginRight: 8,
            }]]), p.Name], ["children", reactApi.Children.toArray(Array.from(elems))]));
        }))))))));
    }], ["renderInput", (p_1) => MuiHelpers_createElement(TextField, toList(delay(() => append_1(Object.entries(p_1), delay(() => append_1(singleton(["variant", "outlined"]), delay(() => append_1(singleton(["color", "primary"]), delay(() => singleton(["label", "Selskap"]))))))))))]]);
}

/**
 * React component used to fetch and render a list of route based on filter.
 */
export function RouteList() {
    let matchValue, elems_7;
    const ctx = reactApi.useContext(globalCtx);
    let patternInput;
    const arg_1 = init((matchValue = ctx.Session, (matchValue != null) ? map((c) => c.Id, matchValue.Companies, Int32Array) : (new Int32Array([]))));
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const isBig = isBig_1(ctx.Responsive);
    let isMobile;
    const matchValue_1 = ctx.Responsive;
    switch (matchValue_1.tag) {
        case 0:
        case 1: {
            isMobile = true;
            break;
        }
        default:
            isMobile = false;
    }
    useEffectOnce(() => {
        fetchRouteList(model_1.Filter, dispatch);
        Company_fetchCompanies((arg_2) => {
            dispatch(new Message(1, [arg_2]));
        });
    });
    const togglePresentationButton = (presentation, label, icon$0027) => {
        let elements;
        return wrapTooltip(label, MuiHelpers_createElement(IconButton, [["onClick", (_arg_1) => {
            if (!equals(model_1.CurrentPres, presentation)) {
                dispatch(new Message(2, [presentation]));
            }
        }], ["size", "small"], (elements = [icon$0027(toList(delay(() => (equals(model_1.CurrentPres, presentation) ? singleton(["style", {
            color: "#0e2d7a",
        }]) : empty_1()))))], ["children", reactApi.Children.toArray(Array.from(elements))])]));
    };
    return createElement("div", createObj(singleton_1((elems_7 = toList(delay(() => append_1(model_1.ShowAddForm ? singleton(createElement(RouteForm, {
        onClose: (_arg_3) => {
            if (_arg_3 == null) {
                dispatch(new Message(5, [false]));
            }
            else {
                dispatch(new Message(6, [_arg_3]));
            }
        },
    })) : empty_1(), delay(() => append_1(singleton(ErrorHandling_snackError(model_1.ErrorMsg, () => {
        dispatch(new Message(10, []));
    })), delay(() => {
        let elems_1;
        return append_1(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "center",
            marginBottom: 1 + "rem",
        }], (elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", "Samband"]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_6;
            return singleton(createElement("div", createObj(ofArray([["key", `route-list-content-${model_1.Routes}`], (elems_6 = toList(delay(() => {
                let elems_4;
                return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    gap: 5 + "px ",
                }], (elems_4 = toList(delay(() => {
                    let elems_2;
                    const matchValue_2 = model_1.Companies;
                    if (matchValue_2 != null) {
                        const c_1 = matchValue_2;
                        return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 5 + "px ",
                            alignItems: "center",
                        }], (elems_2 = [MuiHelpers_createElement(TextField, [["size", "small"], ["variant", "outlined"], ["label", "Søk"], ["defaultValue", model_1.FreeText], ["onChange", (e) => {
                            dispatch(new Message(9, [e.target.value]));
                        }], ["style", {
                            flexGrow: 1,
                            minWidth: 200,
                            maxWidth: 250,
                        }]]), drawCompanyFilter(sortBy((x_1) => x_1.Name, c_1, {
                            Compare: comparePrimitives,
                        }), model_1.Filter.Companies, (x_3) => {
                            let newFilter;
                            const bind$0040 = model_1.Filter;
                            newFilter = (new RouteFilter(x_3, bind$0040.Status, bind$0040.Page, bind$0040.Favorites));
                            fetchRouteList(newFilter, dispatch);
                            dispatch(new Message(8, [newFilter]));
                        }), drawRouteStateFilter(Route_RouteState_AllStatuses(), model_1.Filter.Status, (x_4) => {
                            let newFilter_1;
                            const bind$0040_1 = model_1.Filter;
                            newFilter_1 = (new RouteFilter(bind$0040_1.Companies, x_4, bind$0040_1.Page, bind$0040_1.Favorites));
                            fetchRouteList(newFilter_1, dispatch);
                            dispatch(new Message(8, [newFilter_1]));
                        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                            let elems_3;
                            return singleton(createElement("div", createObj(ofArray([["style", {
                                flexGrow: 1,
                                display: "flex",
                                justifyContent: "flex-end",
                            }], (elems_3 = toList(delay(() => {
                                let props_2;
                                const matchValue_3 = ctx.Session;
                                if (matchValue_3 != null) {
                                    const session = matchValue_3;
                                    return (session.IsSuperAdmin ? true : session.Roles.some((r_1) => {
                                        if (r_1.RoleId === Role__get_Identifier(new Role(3, []))) {
                                            return true;
                                        }
                                        else {
                                            return r_1.RoleId === Role__get_Identifier(new Role(6, []));
                                        }
                                    })) ? singleton(MuiHelpers_createElement(Button, [["color", "primary"], ["startIcon", (props_2 = {}, react.createElement(Add, props_2))], ["size", "small"], ["variant", "contained"], ["style", {
                                        margin: ((((((0 + "px ") + 5) + "px ") + 5) + "px ") + 5) + "px",
                                        color: "#fff",
                                        height: 40,
                                        width: 150,
                                    }], ["onClick", (_arg_2) => {
                                        dispatch(new Message(5, [true]));
                                    }], ["children", "Nytt samband"]])) : empty_1();
                                }
                                else {
                                    return empty_1();
                                }
                            })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                        }));
                    }
                    else {
                        return empty_1();
                    }
                })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                    let elems_5;
                    return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: 5 + "px ",
                        marginBottom: 1 + "rem",
                        minHeight: 41,
                    }], (elems_5 = [togglePresentationButton(new Presentation(0, []), "Kortvisning", (props_10) => {
                        const props_12 = createObj(props_10);
                        return react.createElement(Apps, props_12);
                    }), togglePresentationButton(new Presentation(1, []), "Listevisning", (props_13) => {
                        const props_15 = createObj(props_13);
                        return react.createElement(ViewList, props_15);
                    }), MuiHelpers_createElement(FormControlLabel, [["style", {
                        marginLeft: 0,
                    }], ["checked", model_1.Filter.Favorites], ["control", MuiHelpers_createElement(Checkbox, [["style", {
                        padding: 5,
                    }]])], ["label", "Kun mine samband"], ["onChange", (e_1) => {
                        let newFilter_2;
                        const bind$0040_2 = model_1.Filter;
                        newFilter_2 = (new RouteFilter(bind$0040_2.Companies, bind$0040_2.Status, bind$0040_2.Page, e_1.target.checked));
                        dispatch(new Message(8, [newFilter_2]));
                        fetchRouteList(newFilter_2, dispatch);
                    }]])], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => ((model_1.CurrentPres.tag === 1) ? singleton(drawList(model_1, dispatch, isBig)) : singleton(drawCards(model_1, isMobile)))));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_7))]))));
}

//# sourceMappingURL=RouteList.js.map
